import { Flex, Spacing } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { SalesReportExportLimitBanner } from '../../elements/SalesReportExportLimitBanner'
import { SalesReportStatistics } from '../../elements/SalesReportStatistics'
import { useSalesByItemReport } from '../../hooks/salesByItemReport/useSalesByItemReport'
import { SalesByItemReportTable } from './elements/SalesByItemReportTable'

export const SalesByItemReport = () => {
  const { t } = useTranslation()
  const { salesByItemReport, isLoading } = useSalesByItemReport()

  return (
    <Flex flexDirection="column" gap={Spacing.S8} width="100%">
      <SalesReportExportLimitBanner
        bannerMessage={t('sales_report.export_limit_banner.text.items')}
        localStorageKey={LocalStorageKeys.HideSalesReportItemsExportLimitBanner}
        salesReportCount={salesByItemReport.length}
      />
      <SalesReportStatistics salesReport={salesByItemReport} variant="by-item" isLoading={isLoading} />
      <SalesByItemReportTable />
    </Flex>
  )
}
